import {
  getCityList,
  saveCityAPI,
  deleteCityAPI,
  getCityListCombo
} from '../../../services/DCR/DCRService';

export const fetchDcrCitys = async (statusId) => {
  try {
    const response = await getCityList(statusId);

    if (response && response.success) {
      return response.returnResult || [];
    } else {
      window.showSnackbar({
        message: response?.message || 'An error occurred while fetching citys',
        variant: 'error'
      });
      console.log('Error fetching citys:', response?.message);
      return [];
    }
  } catch (err) {
    window.showSnackbar({
      message: err.message || 'An error occurred while fetching citys',
      variant: 'error'
    });
    console.log('Error fetching citys:', err);
    return [];
  }
};

export const fetchDcrCityListCombo = async () => {
  try {
    const response = await getCityListCombo();

    if (response && response.success) {
      return response.returnResult || [];
    } else {
      window.showSnackbar({
        message: response?.message || 'An error occurred while fetching citys combo',
        variant: 'error'
      });
      console.log('Error fetching citys:', response?.message);
      return [];
    }
  } catch (err) {
    window.showSnackbar({
      message: err.message || 'An error occurred while fetching citys',
      variant: 'error'
    });
    console.log('Error fetching Areas:', err);
    return [];
  }
};

export const saveDcrCity = async (payload, customSuccessMsg, customErrorMsg) => {
  try {
    const response = await saveCityAPI(payload);
    if (!response || !response.success) {
      console.log('response?.message', response?.message || 'Failed to save city');
      window.showSnackbar({
        message: customErrorMsg || `Failed to save city`,
        variant: 'error'
      });
    } else {
      window.showSnackbar({
        message: customSuccessMsg || `city saved successfully`,
        variant: 'success'
      });
    }
    return response;
  } catch (err) {
    const errorMessage = err?.message || (typeof err === 'string' ? err : 'Failed to save city');
    window.showSnackbar({
      message: errorMessage,
      variant: 'error'
    });
    console.log('Failed to save city:', err);
    return { success: false, message: errorMessage };
  }
};

export const deleteDcrCity = async (cityGUID, customSuccessMsg, customErrorMsg) => {
  try {
    const response = await deleteCityAPI(cityGUID);
    if (!response || !response.success) {
      console.log('response?.message', response?.message || 'Failed to delete city');
      window.showSnackbar({
        message: customErrorMsg || `Failed to delete city`,
        variant: 'error'
      });
    } else {
      window.showSnackbar({
        message: customSuccessMsg || `city deleted successfully`,
        variant: 'success'
      });
    }
    return response;
  } catch (err) {
    const errorMessage = err?.message || (typeof err === 'string' ? err : 'Failed to delete city');
    window.showSnackbar({
      message: errorMessage,
      variant: 'error'
    });
    console.log('Failed to delete city:', err);
    return { success: false, message: errorMessage };
  }
};
